import { render } from "./ProyectoList.vue?vue&type=template&id=54463964&scoped=true"
import script from "./ProyectoList.vue?vue&type=script&lang=js"
export * from "./ProyectoList.vue?vue&type=script&lang=js"

import "./ProyectoList.vue?vue&type=style&index=0&id=54463964&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54463964"]])

export default __exports__